export default __webpack_public_path__ + "static/media/after-cf@3x.30913fe8.png";